import ProductGrid from '@nespresso/catalog-components-react/containers/ProductGrid';
import type { ComponentChildren } from 'preact';
import type { Product } from '@/domain/Product';
import ProductNameSection from '../sections/ProductNameSection/ProductNameSection.tsx';
import ProductHeadlineSection from '../sections/ProductHeadlineSection/ProductHeadlineSection.tsx';
import ProductTagsSection from '../sections/ProductTagsSection/ProductTagsSection.tsx';
import ProductImageSection from '../sections/ProductImageSection/ProductImageSection.tsx';
import ProductSpecificationSection from '../sections/ProductSpecificationSection/ProductSpecificationSection.tsx';
import VertuoOversizedCapsuleCompatibilitySection from '../sections/VertuoOversizedCapsuleCompatibilitySection/VertuoOversizedCapsuleCompatibilitySection.tsx';
import ProductPurchaseSection from '../sections/ProductPurchaseSection/ProductPurchaseSection.tsx';
import styles from './CoffeeProductCard.module.scss';
import CardBase from '../CardBase/CardBase.tsx';
import FavoriteButton from '../sections/FavoriteButton/FavoriteButton.tsx';
import useMediaQuery from '@/widgets/hooks/useMediaQuery.tsx';

export type CoffeeProductCardProps = {
  product: Product;
  onClick?: (event: MouseEvent) => void;
  lazyLoadProductImage?: boolean;
  onPurchaseSectionImpression: () => void;
  itemListName: string;
  children?: ComponentChildren;
  class?: string;
  showFavIconWithTitle?: boolean;
};

export default function CoffeeProductCard({
  product,
  onClick,
  lazyLoadProductImage,
  onPurchaseSectionImpression,
  itemListName,
  children,
  class: className,
  showFavIconWithTitle = false
}: CoffeeProductCardProps) {
  const { isMobile } = useMediaQuery();

  return (
    <CardBase
      onClick={onClick}
      extensions={children}
      className={className}
      longSku={product.id}
      shortSku={product.nessoft.legacyId}
      productType={product.type}
    >
      {(isMobile || showFavIconWithTitle) && (
        <FavoriteButton product={product} itemListName={itemListName} />
      )}

      <ProductGrid.GridItemImageSection className={styles.wrapper}>
        {!isMobile && !showFavIconWithTitle && (
          <FavoriteButton product={product} itemListName={itemListName} />
        )}

        <ProductTagsSection product={product} />
        <ProductImageSection
          product={product}
          width={112}
          lazyLoadProductImage={lazyLoadProductImage}
        />
      </ProductGrid.GridItemImageSection>

      <ProductGrid.GridItemContent className={styles.content}>
        <ProductNameSection product={product} />

        <ProductHeadlineSection product={product} class={styles.headline} />

        <ProductSpecificationSection product={product} />
        <VertuoOversizedCapsuleCompatibilitySection product={product} />
      </ProductGrid.GridItemContent>

      <ProductGrid.GridItemFooter>
        <ProductPurchaseSection
          product={product}
          onImpression={onPurchaseSectionImpression}
        />
      </ProductGrid.GridItemFooter>
    </CardBase>
  );
}
